import React from "react";
import { Link, graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/Layout";

const columns = 3;

export default ({ data }) => {
  return (
    <Layout>
      <div
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;

          > * {
            border-right: 1px solid black;
            border-bottom: 1px solid black;
          }

          @media only screen and (max-width: 768px) {
            grid-template-columns: 1fr 1fr;
          }
        `}
      >
        {data.allInventoryJson.edges.map(({ node }) => (
          <div
            key={node.id}
            css={`
              padding-top: 100%;
              position: relative;
            `}
          >
            <Link
              to={node.slug}
              css={`
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 20%;
                display: flex;
                align-items: center;
              `}
            >
              <Img
                fluid={node.images[0].childImageSharp.fluid}
                css={`
                  width: 100%;
                `}
              />
            </Link>
          </div>
        ))}
        <EmptyItems
          n={
            (columns - (data.allInventoryJson.edges.length % columns)) % columns
          }
        />
      </div>
    </Layout>
  );
};

const EmptyItems = ({ n }) => {
  let res = [];
  for (let i = 0; i < n; i++) {
    res.push(<div key={i} />);
  }
  return res;
};

export const query = graphql`
  query {
    allInventoryJson {
      edges {
        node {
          id
          name
          slug
          category
          brand
          images {
            id
            publicURL
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;
